export default __webpack_public_path__ + "media/images/pencil-9dead0f3a32982f2eed9a7e5065b2b32.png";